import axios from "axios"
import { API_URL_LINK } from "./ApiURL"

const API_URL = API_URL_LINK
// const API_URL = "http://localhost:8000/api/"

export const UserLogin = async (body) => {
  try {
    const { data } = await axios.post(`${API_URL}login/loginpasscode`, body)
    return data
  } catch (error) {
    console.log(error)
  }
}
